/**
 * useUpdateJobDetail Hook
 *
 * React Query mutation for PATCH /jobs/job-detail/:jobId.
 * Invalidates the job detail query on success so the UI re-renders from the
 * server-of-record, not a locally-optimistic shape.
 */

import { updateJobDetail } from '@/domains/jobs/api/jobDetailApi';
import { queryKeys } from '@/lib/query-client';
import type { UpdateJobDetailBody } from '@skewb-works/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateJobDetail(jobId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateJobDetailBody) => updateJobDetail(jobId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.jobs.detail(String(jobId)) });
      queryClient.invalidateQueries({ queryKey: queryKeys.jobs.activityLog(String(jobId)) });
    },
    meta: {
      successTitle: 'Job Updated',
      successMessage: 'Job details updated successfully',
    },
  });
}
